var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("empty-state", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      {
        staticClass: "_flexcol _gap-3",
        attrs: { "data-qa": "show-results-button" },
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c(
          "icon-base-button",
          {
            attrs: { icon: "chevron-right", "icon-position": "right" },
            on: { click: _vm.onButtonAction },
          },
          [_vm._v("\n            " + _vm._s(_vm.buttonLabel) + "\n        ")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }